import UserProfileIcon from "@ancon/wildcat-ui/shared/icons/circle-user-outline.svg";
import CompanyIcon from "@ancon/wildcat-ui/shared/icons/company-outline.svg";
import clsx from "clsx";

import styles from "./AuthProfileTypeIcon.module.scss";

function getAuthProfileIcon(isCompany: boolean) {
  if (isCompany) {
    return CompanyIcon;
  }
  return UserProfileIcon;
}

type AuthProfileIconProps = {
  isCompany?: boolean;
  className?: string;
};

export default function AuthProfileTypeIcon({
  isCompany = false,
  className,
}: AuthProfileIconProps) {
  const ProfileIconComponent = getAuthProfileIcon(isCompany);

  return (
    <div className={clsx(styles.iconContainer, className)}>
      <ProfileIconComponent />
    </div>
  );
}
